<template>
  <div class="page-content -column -column-two">
    <h3 class="section-title -mb">Blacklist IPs</h3>

    <form @submit="addBlacklistIp">
      <input v-model="newBlacklistIp" type="text" />
      <action-button :text="'Blacklist IP'" :state="state" @pressed="addBlacklistIp"></action-button>
    </form>

    <div v-if="resource.blacklisted_ips && resource.blacklisted_ips.length > 0" class="basic-list -mt">
      <hr />
      <ul>
        <li v-for="(ip, index) in resource.blacklisted_ips" :key="ip">
          {{ ip }}
          <action-button :state="state" text="Remove" class="-danger -small -right" @pressed="removeBlacklistIp(ip)" />
          <span v-if="dig(errors.blacklisted_ips, index)" class="alert -inline -danger -mt">
            {{ [...dig(errors.blacklisted_ips, index)].join(', ') }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import dig from "object-dig";
import _ from "underscore";

import actionButton from "@/components/actionButton";
import settingsBase from "@/components/settings/base.vue";

export default {
  components: { actionButton },
  extends: settingsBase,

  data() {
    return {
      newBlacklistIp: "",
      fields: ["blacklisted_ips"]
    };
  },

  methods: {
    dig,
    addBlacklistIp() {
      if (this.newBlacklistIp.trim().length > 0) {
        this.resource.blacklisted_ips.unshift(this.newBlacklistIp.trim());
        this.resource.blacklisted_ips = _.uniq(this.resource.blacklisted_ips);

        this.newBlacklistIp = "";
        this.submit();
      }
    },

    removeBlacklistIp(ip) {
      const dupe = _.clone(this.resource);
      dupe.blacklisted_ips = _.without(dupe.blacklisted_ips, ip);
      this.resource = dupe;
      this.submit();
    }
  }
};
</script>
